import React, { useEffect, useState } from 'react';
import NavigationBar from '../../ReusableComp/NavigationBar';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import moment from 'moment';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { getAllStudies,getStudyActive,getNewPmsStudyData } from '../../../Redux/actions/actions';
import { Tooltip } from 'react-tooltip'
import PopUpModal from '../../ReusableComp/PopUpModal';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { ToggleButton } from 'react-bootstrap';
import Loader from '../../ReusableComp/Loader';
import { base_url } from '../../../utilities';
import Pagination from './Pagination';
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 370,
  bgcolor: 'background.paper',
  border: '1px solid #000',
  borderRadius:'7px',
  boxShadow: 24,
  p: 4,    
};

const PMSStudyDetails = () => {
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState('');
  const [filteredStudies, setFilteredStudies] = useState([]);
  let [loading_flag, setloading_flag] = useState(false);
  const dispatch = useDispatch();
  const [modalOpen, setModalOpen] = React.useState(false);
  const getStudies = useSelector((state) => state.getNewPmsStudiesData);

  const getStatus=useSelector((state)=>state.studyActiveStatus);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    if(!localStorage.getItem("login_user_name")){
        navigate("/");
        
    }
}, [navigate]);
  useEffect(() => {
    setloading_flag(true);
  },[])
    useEffect(() => {
        dispatch(getAllStudies());
        dispatch(getNewPmsStudyData());
    }, [dispatch ]);
const tableTitles = [
    '',
    'Protocol Number',
    'Version',
    'Effective Date',
    'Date of Approval',
    'Approval Number',
    'Doses',
    'Subjects',
  ]
// ==================Pagination=======================
const [currentPage1, setCurrentPage1] = useState(1);
   const [postsPerPage] = useState(3);
   const indexOfLastPost = currentPage1 * postsPerPage;
   const indexOfFirstPost = indexOfLastPost - postsPerPage;
 
   const paginate = (pageNumber) => {
      
      setCurrentPage1(pageNumber);
   };


 const nextPage = () => {
    if (currentPage1 !== Math.ceil(getStudies?.length / postsPerPage)) {
       setCurrentPage1(currentPage1 + 1);
       

    }
 };



 const [currentPagePagination, setCurrentPagePagination] = useState(1);
 const CardsPerPage = 3;
 const indexOfLastCard = currentPagePagination * CardsPerPage;
 const indexOfFirstCard = indexOfLastCard - CardsPerPage;
 const currentCards = filteredStudies.slice(indexOfFirstCard, indexOfLastCard);
 const pagination = (pageNumber) => setCurrentPagePagination(pageNumber);

 const jumpToFirstPage = () => setCurrentPagePagination(1);

 const jumpToLastPage = () => setCurrentPagePagination(Math.ceil(filteredStudies.length / CardsPerPage));



useEffect(() => {
  const fetchImages = async () => {
    if (getStudies != null) {
      const updatedStudies = await Promise.all(
        getStudies.map(async (elem) => {
          if (elem.study_thumbnail_image != null && elem.study_thumbnail_image !== '') {
            const queryParams = `?url=${elem.study_thumbnail_image}`;
            const response = await fetch(base_url + 'api/getImage' + queryParams);
            const data = await response.arrayBuffer();
            const base64 = btoa(new Uint8Array(data).reduce((data, byte) => data + String.fromCharCode(byte), ''));
            elem.image_url = `data:${response.headers.get('content-type')};base64,${base64}`;
            return elem;
          } else {
            return elem;
          }
        })
      );
      setFilteredStudies(updatedStudies);
      if (updatedStudies) {
        setloading_flag(false);
      }
    }
  };

  fetchImages();
}, [getStudies]);


const handleSearchData = (e) => {
  paginate(1)
  const searchText = e.target.value;
  setSearchText(searchText);
  const filteredStudies = getStudies.filter((card) =>
    card.study_name.toLowerCase().includes(searchText.toLowerCase())
  );
  setCurrentPagePagination(1)
  setFilteredStudies(filteredStudies);
};


const handleAddNewStudy =()=>{
    navigate('/pmsnewstudysetup')  
}


const [confirmId,setConfirmId]=useState();
const [toggleStates, setToggleStates] = useState({});
const [open, setOpen] = React.useState(false);
const [activeData,setActiveData]=useState()
const [selected, setSelected] = React.useState(false);
let done="";


const handleClosePopup=(reason)=>{
    if (reason !== 'backdropClick') {
            setOpen(true);
          }  
    else{
      setOpen(false);
    }  
    
}
const viewProfile = (studyId) => {
 setOpen(false);
  setToggleStates(prevState => ({
  ...prevState,
  [studyId]: !prevState[studyId],
}));
if(done==="Done"){
  window.location.reload();
}
}

const handleStudyToggle=(studyId)=>{
  setModalOpen(true);
    setToggleStates(prevState => ({
           ...prevState,
           [studyId]: !prevState[studyId],
        }));
    setConfirmId(studyId);
    
    
}
const handleClose = (study,reason) => 

    {
      let studyId=confirmId;
        if (reason !== 'backdropClick') {
            setModalOpen(false);
            setToggleStates(prevState => ({
              ...prevState,
              [studyId]: !prevState[studyId],
           }));
          }    
    }

const handleOpen=()=>{

  setIsLoading(true)
      setModalOpen(false);
      if(toggleStates){
        dispatch(getStudyActive(confirmId));
        setOpen(true);
        setModalOpen(false);
        setActiveData(getStatus);
      }
      setTimeout(() => {
        setIsLoading(false)
      }, 200);
    
}

function getPopupMessage(data) {
  if (data === "estimated subjects count not reached.") {
    return "You cannot deactivate this study because the estimated subjects are not registered for it. Please ask the respective principal investigator to create the subjects..";
  } else if (data === "events reported review pending.") {
    return "The adverse events created under this study have not been closed yet. Please review the report we sent to your email and then request the respective users to close the adverse events related to the subjects.";
  } else if (data === "Study successfully deactivated.") { 
    done="Done";
    return "Study successfully deactivated.";
  } else {
    return "Unknown message"; // Handle other cases if needed
  }
}

function getPopupTitle(data){
  if (data === "estimated subjects count not reached.") {
    return "Warning";
  } else if (data === "events reported review pending.") {
    return "Warning";
  } else if (data === "Study successfully deactivated.") {
    return "Success";
  } else {
    return "Unknown message"; // Handle other cases if needed
  }
}

function getPopupAction(data){
  if (data === "estimated subjects count not reached.") {
    return "Close";
  } else if (data === "events reported review pending.") {
    return "Close";
  } else if (data === "Study successfully deactivated.") {
    return "Done";
  } else {
    return "Unknown message"; // Handle other cases if needed
  }
}


const desiredKeys = [
  'date_of_initiation',
  'protocol_number',
  'version',
  'protocol_effective_date',
  'date_of_approval',
  'approval_number',
  'number_of_doses',
  'estimated_subjects',
  'createdAt'
];
const studiesTitle =  getStudies !==undefined ? getStudies?.map((i) =>({
    date_of_initiation:i.date_of_initiation,
    protocol_number:i.protocol_number,
    version:i.version,
    protocol_effective_date:i.protocol_effective_date,
    date_of_approval:i.date_of_approval,
    approval_number:i.approval_number,
    number_of_doses:i.number_of_doses,
    estimated_subjects:i.estimated_subjects,
    createdAt:i.createdAt,
})):[]
function getPageData (status){
setCurrentPage(status)
}
const [currentPage, setCurrentPage] = useState(1)
const [viewData, setViewData] = useState([]) 
const handlePreview =(data)=>{
setCurrentPage(2)
setViewData(data)
}
const myKeys = (Object.keys(viewData));
const myValues = (Object.values(viewData));

const updatedData = {};

for (const key in myKeys) {
  if (myKeys.hasOwnProperty(key)) {
    const value = myKeys[key];
    const stringValue = String(value);
    const formattedValue = stringValue.replace(/_/g, ' ')
      .replace(/\b\w/g, (match) => match.toUpperCase());
    updatedData[key] = formattedValue;
  }
}

const keysFromApi = (Object.values(updatedData))

const mergedData = myValues.map((keys, index) => {
  if(keysFromApi[Object.keys(keysFromApi)[index]]=='CreatedAt')
    return {
        key: "Created on",
        value: moment(keys).format("DD-MM-YYYY")  
    };
    if(keysFromApi[Object.keys(keysFromApi)[index]]=='Is Active'){
    return {
        key: "Study Status",
        value:keys=== 0?"Deactivated":"Active"
    };
  }
    else{
      return {
        key: keysFromApi[Object.keys(keysFromApi)[index]],
        value: keys 
    };
    }
})
const imageHeaders = new Headers({
  Authorization: "VID ab2ef45d7d932507b9ad1bc63020bad16de02a7b",
});
const [url, setUrl] = useState();


    filteredStudies?.sort((a, b) => b.is_active - a.is_active);
    return (
        <div>
            <NavigationBar studyDropdwn={true} title={'Studies'}/>

           {currentPage===1&& <div className='main_body px-4 py-3'>

           
    {loading_flag ? (
       <div className=''>

       <img
         className="atrium_loader"
         src="/images/circle-effect-loading.gif"
         alt="Loader"

       />
     </div>
      ) : (
        <div>
              <Row  className="study_main">
              <Col>
                <div className="addnew_stdy_btn" style={{marginLeft:"-8px"}}>
                  <button className="orange_btn me-3" onClick={handleAddNewStudy}>
                    Add New Study
                  </button>
                  <input
                    type="text"
                    className="me-3"
                    value={searchText}
                    style={{ width: "400px" }}
                    placeholder="Search with Study Name"
                    onChange={handleSearchData}
                  />
                </div>
              </Col>
               
              <Col className="text-end">


              <div>
      
{currentCards?.length>0 && <Pagination 
jumpToFirstPage={jumpToFirstPage} 
jumpToLastPage={jumpToLastPage}
currentPagePagination={currentPagePagination}
pagination={pagination}
CardsPerPage={CardsPerPage}
filteredStudies={filteredStudies}
/>}
             
    </div>

                {/* <Paginate
                  onPageChange={(number) => paginate(number)}
                  previousPage={previousPage}
                  nextPage={nextPage}
                  pageCount={Math.ceil(filteredStudies?.length / postsPerPage)}
                  postsPerPage={postsPerPage}
                  totalPosts={filteredStudies?.length}
                  currentPage={currentPage1}
                /> */}
              </Col>
            </Row>
            
            <>  {isLoading && <Loader />} 
           
             <div className="d-flex justify-content-end fs-5 pe-4 fw-bold">{filteredStudies?.length >0 ? `Count of studies : ${filteredStudies?.length}` :"" }</div>
             <Row xs={1} md={3} className="study_main ">
                {getStudies !== undefined ? (
                
                  currentCards?.map( (card, idx) => {
                    const cardArray = desiredKeys.map(key => card[key]);
                    card.study_name = card.study_name[0].toUpperCase() + card.study_name.slice(1)
                    return (
                      <div key={idx}>
                        <Col className='py-2'>
                          <Card key={card.id} className='studycard_style'>
                            <Card.Img variant="top"
                             src={card.image_url} 
                            alt="Study Image"
                             style={{ opacity: card.is_active === 0 ? 0.5 : "", 
                             height:"200px", border:"1px solid",
                              borderColor:"#BFBDBD" }}  />
                            <div className='toggle-button '>
                                  <ToggleButton
                                  title='click this button to deactivate the study'
                                    className={card.is_active===1?'btn btn-success btn-sm':'btn btn-danger btn-sm'}
                                      value="check"
                                      selected={toggleStates[card.study_id]}
                                      onClick={() => {
                                        if (card.is_active === 1) {
                                          handleStudyToggle(card.study_id);
                                        }
                                        setSelected(!toggleStates[card.study_id]);
                                      }}
                                      disabled={card.is_active===0}
                                    >
                                      {card.is_active===1?"Active":"Deactivated"}
                                    </ToggleButton>  
                                    
                                      
                                
                                           
                            </div>
                            <Card.Body className='studydetailscardbody' style={{ opacity: card.is_active === 0 ? 0.5 : "" }}>
                              <Card.Title className='card_title_style' data-tooltip-id={card.study_name} data-tooltip-content={card.study_name}>
                                {card.study_name.length > 30 ? `${card.study_name.substring(0, 30)}...` : card.study_name}
                                <Tooltip className='tooltip_study' id={card.study_name} style={{ zIndex: 20 }}/>
                              </Card.Title>
                              <table className="card_table_style">
                                <tbody className='d-flex row p-0'>
                                  {tableTitles.map((title, index) => (
                                    <tr key={index} className='d-flex p-0'>
                                      <td className='pb-2 col-6'>
                                        {title === 'Doses' ? (
                                          <span> <img src="./images/icons/Doses_Covid_Vaccine.svg" alt="" className='me-2' />{title}</span>
                                        ) : title === 'Subjects' ? (
                                          <span> <img src="./images/icons/Persons.svg" alt="" className='me-2' />{title}</span>
                                        ) : title}
                                      </td>
                                      <td className='respo col'>
                                        {title === 'Effective Date' || title === "Date of Approval" ? (
                                          moment(cardArray[index]).format("DD-MM-YYYY")
                                        ) : (
                                          cardArray[index]
                                        )}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </Card.Body>
                            <Card.Footer>
                              <small className="text-muted">{moment(card.createdAt).format("DD-MMM-YYYY HH:MM")}</small>
                              <small className="text-primary C-pointer" onClick={() => handlePreview(card)}>View</small>
                            </Card.Footer>
                          </Card>
                        </Col>
                      </div>
                    );
                  }))
                
                :
                <div className='createStudytxt'>Please click on <b>add new study button</b> to create new study</div>
                }
                  {getStudies !== undefined && currentCards?.length > 0 ? (
                  currentCards?.map((card, idx) => {
                    // ... (your existing code for rendering study cards)
                  })
                ) : (
                  <div className='createStudytxt'> 
                    {searchText
                      ? 'No Studies matched your search criteria'
                      : ''}
                  </div>
                )}
                </Row></> 
                <PopUpModal
            handleClose={handleClosePopup}
            open={open}
            title={getStatus && getPopupTitle(getStatus)}
            msg={getStatus && getPopupMessage(getStatus)}
            close={"Close"}
            actionbtn={getStatus && getPopupAction(getStatus)}
            onConfirm={()=>{viewProfile(confirmId)}}
            backdrop="static"
        />        
          <Modal
        open={modalOpen}
        onClose={()=>{handleClose(confirmId,'backdropClick')}}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
       
      >
        <Box sx={style} >
          <Typography id="modal-modal-description" sx={{ mt: 1,mb:3 }} style={{overflowY:"auto"}}>
            <div style={{fontSize:"16px",fontWeight:"bold"}}> Do you want to deactivate this study?</div>
          </Typography>
          <div className='d-flex flex-row justify-content-center'>
            <button className='btn btn-success' onClick={()=>handleOpen()} style={{marginRight:"20px"}}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="20" fill="currentColor" className="bi bi-check-lg" viewBox="0 0 16 16" style={{marginRight:"3px"}}>
          <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"/>
        </svg>
              Yes
          
              </button>
            <button className='btn btn-secondary' onClick={()=>handleClose()}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="20" fill="currentColor" className="bi bi-x" viewBox="0 0 16 16" style={{marginRight:"3px"}}>
              <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
            </svg>
              No
           
            </button>
          </div>
        </Box>
      </Modal>
          </div>    

      )}
                 
            </div>}
            
            {  currentPage ===2 &&
               <PreviewStudy getPageData={getPageData} mergedData={mergedData}/> 
                
            }
            
        </div>
        
    );
};

export default PMSStudyDetails;



  



const PreviewStudy = ({getPageData, mergedData}) => {
    if(window.pageYOffset>100){
      window.scrollTo(900, 0);
    } 
   
  
  const status ='Active'
  return (
    <div className='main_body p-4' >
                <div className='d-flex '>
                <button className='white_btn white_btn_back'  onClick={() =>getPageData(1)}>Back </button> 
                 </div>
                 <div>
                 </div>
                             <div className="study_view_window">
                                 <Card className="previewCard">
                                 <Card.Header className='h4 text-secondary text-start bg-white'>Study Details</Card.Header>
                             {mergedData.map((i, index) => {
                                 if (i.key !== "Duration Between Doses Type")
                                    return (
                                      <div key={index} className='row text-start d-flex justify-content-between'>
                                        <span className='col'>
                                          {i.key !== "Study Id" && i.key !== "Is Deleted" && i.key!=="Study Thumbnail Image" && i.key!=="Image Url" ? (
                                            <span>{i.key + ":"}</span>
                                          ) : (
                                            ''
                                          )}
                                        </span>
                                        <span className='col previewvalues'>
                                          {i.key !== "Study Id" && i.key !== "Is Deleted" && i.key!=="Study Thumbnail Image" && i.key!=="Image Url" ? (
                                            i.key === 'Protocol Effective Date' ||
                                            i.key === 'Study Initiation Date' ||
                                            i.key === 'Date Of Approval' ||
                                            i.key === 'CreatedAt' ||
                                            i.key === 'UpdatedAt'
                                              ? moment(i.value).format('DD-MM-YYYY')
                                              : i.key === 'Active Follow Up' || i.key === 'Safety Follow Up'
                                              ? i.value + ' Days'
                                              : i.key === 'Duration Between Doses'
                                              ? i.value + ' Days'
                                              : i.key === 'Immediate Adverse Event'
                                              ? i.value + ' Mins'
                                              : i.key === 'Age Group'
                                              ? i.value + ' Yrs'
                                              : i.key === "Is Active" 
                                              ? i.value
                                              : i?.key === "spoc"
                                              ? i?.value
                                              : i.value
                                              
                                              
                                          ) : (
                                            ''
                                          )}
                                        </span>
                                      </div>
                                    );
                                  })}
                                 </Card>
                             </div>
                
                             </div>
  );
};

 ;

 

